import React, { useEffect, useState, useRef } from 'react';
import './SettingsPopup.css'; // Make sure to link the CSS file
import './Userpage.css';
import './Settingspopupadd.css';
import { useUserAuth } from "../context/UserAuthContext";
import { GPT_PROMPT_CONTENT, PRESETS_DEFAULT_LIST, languageOptions, PRESETS_DEFAULT_LIST_CN } from './Keywords';
import e from 'cors';
import { set } from 'react-hook-form';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


let saveBtnPressed = false;

const SettingsPopup = ({ isVisible, onClose, onSave }) => {
  // Placeholder for handling input changes
  const { userDataLocal, updateUserFirestoreData, setNeedUpdate, userVipLevel, openPricePopup, setOpenPricePopup, 
    setNeedResetGPTPrompt, setNeedResetAilaunchmode, setCurrentUpdateReason } = useUserAuth();
  const [userInfo, setUserInfo] = useState(userDataLocal);
  const [userDataChanged, setUserDataChanged] = useState(false);
  const [isVisibleSettings, setIsVisibleSettings] = useState(false);

  const [justPresetChanged, setJustPresetChanged] = useState(false);
  
  const textAreaRefTranscript = useRef(null);
  const textAreaRefKeywords = useRef(null);
  const textAreaRefGPTPromptContent = useRef(null);

  const [languageData, setLanguageData] = useState(userDataLocal?.Language || {lan: 'Chinese', code: 'zh-CN'});
  const [languageOtherData, setLanguageOtherData] = useState(userDataLocal?.LanguageOther || {lan: 'Chinese', code: 'zh-CN'});
  const [gptVersionData, setGptVersionData] = useState(null);
  const [audioSetData, setAudioSetData] = useState(null);
  const [aiLaunchModeData, setAiLaunchModeData] = useState(null);
  const [autoStopTimeData, setAutoStopTimeData] = useState(300000);
  const [aiResponseMode, setAiResponseMode] = useState('Text');
  const [transcriptionModeData, setTranscriptionModeData] = useState('Real-time');

  const [summaryLength, setSummaryLength] = useState(null); //Brief, Moderate, Precise
  const [textAreaValueTranscript, setTextAreaValueTranscript] = useState('');
  const [textAreaValueKeywords, setTextAreaValueKeywords] = useState('');
  const [textAreaValueGPTPromptContent, setTextAreaValueGPTPromptContent] = useState('');

  const presetsCombine = userDataLocal.Language.lan ==='English' ? {...PRESETS_DEFAULT_LIST, ...userDataLocal?.PreSet?.setDictionary} : {...PRESETS_DEFAULT_LIST_CN, ...userDataLocal?.PreSet?.setDictionary};
  const presetDefault = userDataLocal.Language.lan ==='English' ? PRESETS_DEFAULT_LIST.Default : PRESETS_DEFAULT_LIST_CN.通用场景;

  const [presets, setPresets] = useState(userDataLocal?.PreSet?.setDictionary||{});
  const [nameOFSelectedPreset, setNameOFSelectedPreset] = useState(userDataLocal?.PreSet?.defaultSetName || '通用场景');

  const [selectedPreset, setSelectedPreset] = useState(userDataLocal?.PreSet?.defaultSetName && userDataLocal?.PreSet?.defaultSetName!=='' ? presetsCombine[userDataLocal?.PreSet?.defaultSetName]:presetDefault);
  const [presetsTempConvert, setPresetsTempConvert] = useState(Object.values(presetsCombine));

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if(userDataLocal){
      resetUserInfo();
    }
    setIsVisibleSettings(true);
    return () => {
      setIsVisibleSettings(false);
      setUserDataChanged(false);
    };
  }, []);

  useEffect(() => {
    if (textAreaRefTranscript.current) {
      autoResizeTextarea(textAreaRefTranscript.current);
    }
  }, [textAreaValueTranscript]);

  useEffect(() => {
    if (textAreaRefKeywords.current) {
      autoResizeTextarea(textAreaRefKeywords.current);
    }
  }, [textAreaValueKeywords]);

  useEffect(() => {
    if (textAreaRefGPTPromptContent.current) {
      autoResizeTextarea(textAreaRefGPTPromptContent.current);
    }
  }, [textAreaValueGPTPromptContent]);

  useEffect(() => {
    // console.log('selectedPreset:', selectedPreset);
    if(selectedPreset){
      // console.log('selectedPreset:', selectedPreset);
      setNameOFSelectedPreset(selectedPreset.Name);
      setLanguageData(selectedPreset?.Language || {lan: 'Chinese', code: 'zh-CN'});
      setLanguageOtherData(selectedPreset?.LanguageOther || {lan: 'Chinese', code: 'zh-CN'});
      setGptVersionData(selectedPreset.GPTVersion);
      setAudioSetData(selectedPreset.AudioSet);
      setAiLaunchModeData(selectedPreset.Ailaunchmode);
      setSummaryLength(selectedPreset.SummaryLength);
      setAutoStopTimeData(parseInt(selectedPreset?.AutoStopTime || '300000') || 300000);
      setAiResponseMode(selectedPreset?.AIResponseMode || 'Text' );
      setTranscriptionModeData(selectedPreset?.TranscriptionMode || 'Real-time');
      // console.log('selectedPreset:', selectedPreset);
      // console.log('selectedPreset?.SummarySet:', selectedPreset?.SummarySet);
      // console.log('selectedPreset?.Keywords:', selectedPreset?.Keywords);
      const summary = Array.isArray(selectedPreset?.SummarySet) ? selectedPreset?.SummarySet.join(', ') : selectedPreset?.SummarySet;
      const keywords = Array.isArray(selectedPreset?.Keywords) ? selectedPreset?.Keywords.join(', ') : selectedPreset?.Keywords;
      setTextAreaValueTranscript(summary);
      setTextAreaValueKeywords(keywords);
      setTextAreaValueGPTPromptContent(selectedPreset.GPTPromptContent);

      setUserInfo({
        ...userInfo,
        Language: selectedPreset.Language,
        LanguageOther: selectedPreset?.LanguageOther || {lan: 'Chinese', code: 'zh-CN'},
        GPTVersion: selectedPreset.GPTVersion,
        AudioSet: selectedPreset.AudioSet,
        Ailaunchmode: selectedPreset.Ailaunchmode,
        SummaryLength: selectedPreset.SummaryLength,
        SummarySet: selectedPreset?.SummarySet,
        PreSet: {
          defaultSetName: selectedPreset.Name,
          setDictionary: presets
        },
        GPTPromptContent: selectedPreset.GPTPromptContent,
        Keywords: selectedPreset?.Keywords,
        Readme: selectedPreset.Readme,
        OtherValue: selectedPreset.OtherValue,
        AutoStopTime: selectedPreset?.AutoStopTime || 300000,
        AIResponseMode: selectedPreset?.AIResponseMode || 'Text',
        TranscriptionMode: selectedPreset?.TranscriptionMode || 'Real-time',
      });

    }
    return () => {
    }
  }, [selectedPreset]);

  useEffect(() => {
    const presetsCombinetemp = userDataLocal.Language.lan ==='English' ? {...PRESETS_DEFAULT_LIST, ...presets} : {...PRESETS_DEFAULT_LIST_CN, ...presets};
    setPresetsTempConvert(Object.values(presetsCombinetemp));

    if(saveBtnPressed){
      handleSave()
    }

    // console.log('presets:', presets);
    // } else {
    //   if(!userInfo?.PreSet?.setDictionary) {
    //     let defaultPreset = 'Default';
    //     setUserInfo(prevState => ({
    //       ...prevState,
    //       PreSet: {
    //         defaultSetName: defaultPreset,
    //         setDictionary: presets
    //       }
    //     }));
        
    //     setSelectedPreset(presets[defaultPreset]);
    //   } else {
    //     let defaultPreset = nameOFSelectedPreset;
    //     setUserInfo(prevState => ({
    //       ...prevState,
    //       PreSet: {
    //         defaultSetName: defaultPreset,
    //         setDictionary: presets
    //       }
    //     }));
    //   }
    // }
  }, [presets]);

  // useEffect(() => {
  //   if(userVipLevel === 0){
  //     if (!openPricePopup && (summaryLength !== selectedPreset?.SummaryLength)) {
  //       setOpenPricePopup(true);
  //       setSummaryLength(userDataLocal?.SummaryLength||'Moderate');
  //     }
  //     // handleSave();
  //   } else {
  //     setUserInfo(prevState => ({
  //       ...prevState,
  //       SummaryLength: summaryLength
  //     }));
  //     setUserDataChanged(true);
  //   }
  // }, [summaryLength]);

  useEffect(() => {
    if(!userDataChanged){
      resetUserInfo();//更新用户界面的显示数据
    }
  }, [userDataLocal]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  // useEffect(() => {
  //   if (textAreaRefTranscript.current) {
  //       setDivHeight(textAreaHeight);
  //     }
  // }, [textAreaHeight]);

  

  // useEffect(() => {
  //   if(userDataChanged) console.log('User data changed:', userInfo);
  //   setUserDataChanged(false);
  // }, [userDataChanged]);

  function autoResizeTextarea(textarea) {
    // 先重置高度，以便重新计算
    textarea.style.height = 'auto';
    // 设置高度为内容的实际高度
    textarea.style.height = textarea.scrollHeight + 'px';
  }
  

  const resetUserInfo = () => {
    // Placeholder for resetting user info
    setUserInfo(userDataLocal);
    const presetTemp = userDataLocal?.PreSet?.setDictionary || {};
    const isNotEmpty = Object.keys(presetTemp).length > 0;
    if(isNotEmpty) {
      setPresets(userDataLocal?.PreSet?.setDictionary);
      let defaultPreset = userDataLocal?.PreSet?.defaultSetName;
      if (!defaultPreset || defaultPreset === '') defaultPreset = '通用场景';
      // setUserInfo(prevState => ({
      //   ...prevState,
      //   PreSet: {
      //     defaultSetName: defaultPreset,
      //     setDictionary: presetTemp
      //   }
      // }));
      const presetsCombineTemp = userDataLocal.Language.lan ==='English' ? {...PRESETS_DEFAULT_LIST, ...presetTemp} : {...PRESETS_DEFAULT_LIST_CN, ...presetTemp};
      setPresetsTempConvert(Object.values(presetsCombineTemp));
      setSelectedPreset(presetsCombineTemp[defaultPreset]);
    }
  };

  const handleSave = () => {
    console.log('Saving settings...');

    let SummarySetSetting= (String(textAreaValueTranscript) || '').split(',').map(item => item.trim());
    let KeywordsSetting=(String(textAreaValueKeywords) || '').split(',').map(item => item.trim());

    let newGPTPromptContent = userInfo.GPTPromptContent;
    const replyStringPattern = /\n Please reply in .+\.$/;
    if (replyStringPattern.test(newGPTPromptContent)) {
      newGPTPromptContent = newGPTPromptContent.replace(replyStringPattern, '');
    }

    let language = userInfo.Language.lan;
    const keywords = ['翻译', 'translate', '翻譯', 'translator', 'Translator', 'Translate'];
    // const containsTranslate = keywords.some(keyword => newGPTPromptContent?.includes(keyword));
    const containsTranslate = newGPTPromptContent ? keywords.some(keyword => newGPTPromptContent.includes(keyword)): false;
    // const containsTranslate = newGPTPromptContent.includes('翻译') || newGPTPromptContent.includes('translate') || newGPTPromptContent.includes('翻譯') || newGPTPromptContent.includes('translator') || newGPTPromptContent.includes('Translator')|| newGPTPromptContent.includes('Translate');

    if (!containsTranslate) {
      newGPTPromptContent += '\n Please reply in ' + language + '.';
      setUserInfo({
        ...userInfo,
        GPTPromptContent: newGPTPromptContent,
      });
    }

    setNeedResetGPTPrompt(true);
    
    if (userDataChanged || userDataLocal?.PreSet?.defaultSetName !== nameOFSelectedPreset) {

      updateUserFirestoreData({ 
        SummarySet: SummarySetSetting,
        Keywords: KeywordsSetting,
        SummaryLength: userInfo.SummaryLength,
        Language: userInfo.Language,
        LanguageOther: userInfo?.LanguageOther || {lan: 'Chinese', code: 'zh-CN'},
        GPTVersion: userInfo.GPTVersion,
        AudioSet: userInfo.AudioSet,
        GPTPromptContent: newGPTPromptContent || GPT_PROMPT_CONTENT.prompt,
        Ailaunchmode: userInfo.Ailaunchmode,
        PreSet: userInfo.PreSet,
        AutoStopTime: userInfo?.AutoStopTime || 300000,
        AIResponseMode: userInfo?.AIResponseMode || 'Text',
        TranscriptionMode: userInfo?.TranscriptionMode || 'Real-time',
      })
        .then(() => {
          setNeedUpdate(true); 
          setCurrentUpdateReason('settingPageChanged');
          setUserDataChanged(false);
        }).catch(error => {
          console.error("Failed to update user data in Firestore", error);
        });
    }
    saveBtnPressed = false;
    onSave();
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if(userVipLevel === 0 && (name !== 'Language') && (name !== 'PreSet')){
      if (!openPricePopup) setOpenPricePopup(true);
      // if (name === 'SummarySet') event.target.value = textAreaValueTranscript;
      // if (name === 'Keywords') event.target.value = textAreaValueKeywords;
      return;
    }

    if (name === 'GPTPromptContent' && userInfo[name] !== value) {
      setNeedResetGPTPrompt(true);
    } else {
      setNeedResetGPTPrompt(false);
    }

    if (name === 'Ailaunchmode' && userInfo[name] !== value) {
      setNeedResetAilaunchmode(true);
    } else {
      setNeedResetAilaunchmode(false);
    }

    if (name === 'PreSet' ) {
      // 此处需要重新载入当前弹窗的设置
      setJustPresetChanged(true);
      setNameOFSelectedPreset(value);
      const presetsCombineTemp = userDataLocal.Language.lan ==='English' ? {...PRESETS_DEFAULT_LIST, ...presets} : {...PRESETS_DEFAULT_LIST_CN, ...presets};
      setSelectedPreset(presetsCombineTemp[value]);

      // console.log('Preset changed to:', value);
    } 
  
    if (name === 'Language' || name === 'LanguageOther') {
      const selectedLanguage = languageOptions.find(option => option.value === value);
      if (name === 'Language') {
        setLanguageData(selectedLanguage);
      } else if (name === 'LanguageOther') {
        setLanguageOtherData(selectedLanguage);
      }
      setUserInfo(prevState => ({
        ...prevState,
        [name]: {
          lan: selectedLanguage.label,
          code: value
        }
      }));
      setUserDataChanged(true);
    } else if (name === 'PreSet') {
      // setUserInfo(prevState => ({
      //   ...prevState,
      //   PreSet: {
      //     defaultSetName: value,
      //     setDictionary: presets
      //   }
      // }));
    } else {
      setUserInfo(prevState => ({
        ...prevState,
        [name]: value
      }));
      if(name === 'GPTVersion') setGptVersionData(value);
      if(name === 'AudioSet') setAudioSetData(value);
      if(name === 'Ailaunchmode') setAiLaunchModeData(value);
      if(name === 'AutoStopTime') setAutoStopTimeData(value);
      if(name === 'AIResponseMode') setAiResponseMode(value);
      if(name === 'TranscriptionMode') setTranscriptionModeData(value);
      setUserDataChanged(true);
    }
  };

  const handleInputTranscript = (event) => {
    if(userVipLevel > 0){
      setTextAreaValueTranscript(event.target.value);
      // if (textAreaRefTranscript.current) {
      //   textAreaRefTranscript.current.style.height = '0';
      //   const scrollHeight = textAreaRefTranscript.current.scrollHeight;
      //   if (scrollHeight >= 300) {
      //     textAreaRefTranscript.current.style.overflow = 'auto';
      //     textAreaRefTranscript.current.style.height = '300px';
      //   } else {
      //     textAreaRefTranscript.current.style.overflow = 'hidden';
      //     textAreaRefTranscript.current.style.height = `${scrollHeight}px`;
      //   }
      //   setTextAreaHeight(`${textAreaRefTranscript.current.style.height}px`);
      // }
    }
    handleInputChange({
      target: {
        name: 'SummarySet', // 这应该是你希望更新的userInfo属性的名称
        value: event.target.value,
      },
    });
  };

  const handleInputGPTPromptContent = (event) => {
    if(userVipLevel > 0){
      setTextAreaValueGPTPromptContent(event.target.value);
      // if (textAreaRefGPTPromptContent.current) {
      //   textAreaRefGPTPromptContent.current.style.height = '0';
      //   const scrollHeight = textAreaRefGPTPromptContent.current.scrollHeight;
      //   if (scrollHeight >= 200) {
      //     textAreaRefGPTPromptContent.current.style.overflow = 'auto';
      //     textAreaRefGPTPromptContent.current.style.height = '200px';
      //   } else {
      //     textAreaRefGPTPromptContent.current.style.overflow = 'hidden';
      //     textAreaRefGPTPromptContent.current.style.height = `${scrollHeight}px`;
      //   }
      //   setTextAreaHeightGPTPromptContent(`${textAreaRefTranscript.current.style.height}px`);
      // }
    }
    handleInputChange({
      target: {
        name: 'GPTPromptContent', 
        value: event.target.value,
      },
    });
  }

  const handleInputKeywords = (event) => {
    if(userVipLevel > 0){
      setTextAreaValueKeywords(event.target.value);
      // if (textAreaRefKeywords.current) {
      //   textAreaRefKeywords.current.style.height = '0';
      //   textAreaRefKeywords.current.style.height = `${textAreaRefKeywords.current.scrollHeight}px`;
      // }
    }
    handleInputChange({
      target: {
        name: 'Keywords', // 这应该是你希望更新的userInfo属性的名称
        value: event.target.value,
      },
    });
  }

  const handleSummaryLengthChange = (summarylenthvalue) => {
    setSummaryLength(summarylenthvalue);
    if(userVipLevel === 0){
      if (!openPricePopup && (summarylenthvalue !== selectedPreset?.SummaryLength)) {
        setOpenPricePopup(true);
        setSummaryLength(userDataLocal?.SummaryLength||'Moderate');
      }
      // handleSave();
    } else {
      setUserInfo(prevState => ({
        ...prevState,
        SummaryLength: summarylenthvalue
      }));
      setUserDataChanged(true);
    }
  } 

  //2024.07.11 preset
  const handleSavePreset = () => {
    if (userDataChanged) {

      let SummarySetSetting= (String(textAreaValueTranscript) || '').split(',').map(item => item.trim());
      let KeywordsSetting=(String(textAreaValueKeywords) || '').split(',').map(item => item.trim());
      let presetName = prompt("Enter a new name for the current setting, or leave blank to overwrite the current setting:");
      // const keyOfCurrentSet = Object.keys(selectedPreset);
      const presetsCombineTemp = userDataLocal.Language.lan ==='English' ? {...PRESETS_DEFAULT_LIST, ...presets} : {...PRESETS_DEFAULT_LIST_CN, ...presets};
      if (PRESETS_DEFAULT_LIST[presetName] || PRESETS_DEFAULT_LIST_CN[presetName] || ((!presetName || presetName === '') && (PRESETS_DEFAULT_LIST[nameOFSelectedPreset] || PRESETS_DEFAULT_LIST_CN[nameOFSelectedPreset]))) {
        alert("This preset name already exists: Since the current input conflicts with the system's built-in name, please try renaming it and saving again.");
        return;
      }
      if (presetName && presetName !=='' && !presets[presetName]) {
        // If the preset name does not exist, save as a new record
        presets[presetName] = {
          Name: presetName,
          Language: userInfo.Language,
          LanguageOther: userInfo?.LanguageOther || {lan: 'Chinese', code: 'zh-CN'},
          GPTVersion: userInfo.GPTVersion,
          AudioSet: userInfo.AudioSet,
          Ailaunchmode: userInfo.Ailaunchmode,
          GPTPromptContent: userInfo.GPTPromptContent,
          SummaryLength: userInfo.SummaryLength,
          SummarySet: SummarySetSetting,
          Keywords: KeywordsSetting,
          Readme: 'readme',
          AutoStopTime: userInfo?.AutoStopTime || 300000,
          AIResponseMode: userInfo?.AIResponseMode || 'Text',
          TranscriptionMode: userInfo?.TranscriptionMode || 'Real-time',
          OtherValue: '',
          
        };
        // alert("Preset saved successfully.");
      } else {
        // If the preset name exists, confirm overwrite
        let isOverwrite = true;
        if (!presetName || presetName !=='') {
          isOverwrite = window.confirm("You did not provide a name, the current record will be overwritten. Do you want to continue?"); 
        } else {
          isOverwrite = window.confirm("This preset name already exists. Do you want to overwrite it?");
        }
        if (isOverwrite) {
          presetName = nameOFSelectedPreset;
          presets[presetName] = {
            Name: presetName,
            Language: userInfo.Language,
            LanguageOther: userInfo?.LanguageOther || {lan: 'Chinese', code: 'zh-CN'},
            GPTVersion: userInfo.GPTVersion,
            AudioSet: userInfo.AudioSet,
            Ailaunchmode: userInfo.Ailaunchmode,
            GPTPromptContent: userInfo.GPTPromptContent,
            SummaryLength: userInfo.SummaryLength,
            SummarySet: SummarySetSetting,
            Keywords: KeywordsSetting,
            Readme: 'readme',
            AutoStopTime: userInfo?.AutoStopTime || 300000,
            AIResponseMode: userInfo?.AIResponseMode || 'Text',
            TranscriptionMode: userInfo?.TranscriptionMode || 'Real-time',
            OtherValue: ''
          };
          // alert("Preset updated successfully.");
        } else {
          // alert("Preset save cancelled.");
          return;
        }
      }
      setUserInfo({
        ...userInfo,
        PreSet: {
          defaultSetName: presetName,
          setDictionary: presets
        }
      });
      setSelectedPreset(presets[presetName]);
    } else if(justPresetChanged){
      setUserInfo({
        ...userInfo,
        PreSet: {
          defaultSetName: nameOFSelectedPreset,
          setDictionary: presets
        }
      });
      setUserDataChanged(true);
      setJustPresetChanged(false);
    }
    saveBtnPressed = true;
    setTimeout(() => {
      setPresets({ ...presets });   //没有实质性的变化，只是通知钩子函数更新
    }, 50);
  };
  
  const handleSelectPreset = (selectedPresetName) => {
    setIsDropdownOpen(false);
    if(userVipLevel > 0){
      // setTextAreaValueTranscript(event.target.value);
    }
    handleInputChange({
      target: {
        name: 'PreSet', // 这应该是你希望更新的userInfo属性的名称
        value: selectedPresetName,
      },
    });
  };
  
  // const handleDeletePreset = (selectedPresetName, event) => {
  //   event.stopPropagation(); // 阻止事件冒泡到选项选择逻辑
  //   if (selectedPresetName) {
  //     if (nameOFSelectedPreset === selectedPresetName) {
  //       setSelectedPreset(PRESETS_DEFAULT_LIST.Default);
  //       setJustPresetChanged(true);
  //     }
  //     setPresets(presets.filter(p=> p.name !== selectedPresetName));
  //   }
  // };

  const handleDeletePreset = (selectedPresetName, event) => {
    event.stopPropagation(); // 阻止事件冒泡到选项选择逻辑
    if (selectedPresetName) {
      const updatedPresets = { ...presets };
      delete updatedPresets[selectedPresetName];
      console.log('nameOFSelectedPreset:', nameOFSelectedPreset);
      console.log('selectedPresetName:', selectedPresetName);
      if (nameOFSelectedPreset === selectedPresetName) {
        const defaultPreset = userDataLocal.Language.lan ==='English' ? PRESETS_DEFAULT_LIST.Default : PRESETS_DEFAULT_LIST_CN.通用场景;
        setSelectedPreset(defaultPreset);
      }
      setJustPresetChanged(true);
      setPresets(updatedPresets);
    }
  };

  const autoStopTimeOptions = [
    // { label: "15 seconds", value: 15000 },
    // { label: "30 seconds", value: 30000 },
    { label: "1 minute", value: 60000 },
    { label: "2 minutes", value: 120000 },
    { label: "5 minutes", value: 300000 },
    { label: "10 minutes", value: 600000 }
  ];



  return (

    <div className={`popup-settingsnew-overlay ${isVisibleSettings ? 'active' : ''}`}>
      <div className="popup-settingsnew">
        <div className="popup-settingsnew-header">Nvoice Setting</div>
        <div className="popup-settingsnew-body">

          <div className="popup-settingsnew-left">

            {/* <div className="info-item info-item-fontsizeadjust"> */}
            {/* <label htmlFor="presets-set">Presets:</label>
              <select id="presets-set" name="PreSet" value={nameOFSelectedPreset} onChange={handleInputChange} className="appstyle-mode-selector">
                {presetsTempConvert.map(preset => (
                  <option key={preset.Name} value={preset.Name}>
                    {preset.Name}
                  </option>
                ))}
              </select> */}

              <label htmlFor="presets-set" title="Select or customize an application scenario">Presets:</label>
              <div className="custom-dropdown-settingpop">
                {!isDropdownOpen && 
                  <div className="dropdown-header-settingpop" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    {nameOFSelectedPreset || "Select a preset"} {<FontAwesomeIcon icon={faChevronDown} className="appstyle-btn-interspace" style={{width:'10px', color:'#7d7d7d', paddingLeft:'30px', paddingRight:'3px'}}/>}
                  </div>}
                {isDropdownOpen && (
                  <div className="dropdown-list-settingpop" ref={dropdownRef}>
                    {presetsTempConvert.map((preset) => (
                      <div key={preset.Name} className="dropdown-item-settingpop" onClick={() => handleSelectPreset(preset.Name)} style={{cursor:'pointer'}}>
                        <span>{preset.Name}</span>
                        {Object.keys(presets).includes(preset.Name) && (
                          <button onClick={(e) => handleDeletePreset(preset.Name, e)} style={{marginLeft:'10px'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" className="bi bi-trash" viewBox="0 0 15 15">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                              <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

            <label htmlFor="language-set" title='The main language used in the current scenario.'>1st Language:</label>
              <select id="language-set" name="Language" value={languageData.code} onChange={handleInputChange} className="appstyle-mode-selector">
                {languageOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

            <label htmlFor="languageOther-set" title='The second language used in the current scenario. This option is best used when real-time translation is required.'>2nd Language:</label>
              <select id="languageOther-set" name="LanguageOther" value={languageOtherData.code} onChange={handleInputChange} className="appstyle-mode-selector">
                {languageOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            {/* </div> */}

            {/* <div className="info-item info-item-fontsizeadjust"> */}
              {/* <label htmlFor="gpt-version" title='GPT version'>
                  GPT Version:
              </label>
              <div id="gpt-version" className="style-of-settingdiv">
                <label htmlFor="GPT-3.5" title="GPT-3.5" className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px','margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="GPT-3.5"
                      name="GPTVersion"
                      value="GPT-3.5"
                      checked={gptVersionData === 'GPT-3.5'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>GPT-3.5
                </label>

                <label htmlFor="GPT-4" title="GPT-4.0" className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px', 'margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="GPT-4"
                      name="GPTVersion"
                      value="GPT-4"
                      checked={gptVersionData === 'GPT-4'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>GPT-4
                </label>

                <label htmlFor="GPT-4o" title="GPT-4o" className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px', 'margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="GPT-4o"
                      name="GPTVersion"
                      value="GPT-4o"
                      checked={gptVersionData === 'GPT-4o'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>GPT-4o
                </label>

                <label htmlFor="GPT-4o mini" title="GPT-4o mini" className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px'}}>
                  <input
                      type="radio"
                      id="GPT-4o mini"
                      name="GPTVersion"
                      value="GPT-4o mini"
                      checked={gptVersionData === 'GPT-4o mini'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>GPT-4o mini
                </label>
              </div> */}
            {/* </div> */}

            {/* <div className="info-item info-item-fontsizeadjust"> */}
              <label htmlFor="audio-set" title='Audio Format'> Audio setting:</label>
              <div id="audio-set" style={{'display': 'flex'}}>
                <label htmlFor="wav" title="wav" className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px', 'margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="wav"
                      name="AudioSet"
                      value="wav"
                      checked={audioSetData === 'wav'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>wav
                </label>

                <label htmlFor="mp3" title="mp3"  className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px'}}>
                  <input
                      type="radio"
                      id="mp3"
                      name="AudioSet"
                      value="mp3"
                      checked={audioSetData === 'mp3'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>mp3
                </label>
              </div>
            {/* </div> */}
              
              <label htmlFor="ai-launch-mode" title='When or how to activate AI'>
                  Launch AI by:
              </label>
              <div id="ai-launch-mode"  className="style-of-settingdiv">
                <label htmlFor="by-keywords" title='When the keywords you preset appear in the conversation, the AI will be called immediately to get a reply.' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px','margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="by-keywords"
                      name="Ailaunchmode"
                      value="Keywords"
                      checked={aiLaunchModeData === 'Keywords'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>Keywords
                </label>

                <label htmlFor="by-AI" title='AI ​​will automatically determine which topics require an AI response when the speaker takes a short break. Of course, the specific scope of the response also depends on your prompt word settings.' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px', 'margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="by-AI"
                      name="Ailaunchmode"
                      value="AI"
                      checked={aiLaunchModeData === 'AI'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>AI
                </label>

                <label htmlFor="by-Select" title='AI will be called in real time to get answers based on the paragraphs selected by your mouse on site.' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px', 'margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="by-Select"
                      name="Ailaunchmode"
                      value="Select"
                      checked={aiLaunchModeData === 'Select'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>Select
                </label>

                <label htmlFor="by-Enter" title='When you press Enter, the content between this Enter and the last Enter will be sent to the AI ​​for help.' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px'}}>
                  <input
                      type="radio"
                      id="by-Enter"
                      name="Ailaunchmode"
                      value="Enter"
                      checked={aiLaunchModeData === 'Enter'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>Enter
                </label>
              </div>

              <label htmlFor="airesponsemode-set" title='AI feedback form: text or voice' > AI response mode:</label>
              <div id="airesponsemode-set" style={{'display': 'flex'}}>
                <label htmlFor="text" title='AI feedback form: text' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px', 'margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="text"
                      name="AIResponseMode"
                      value="Text"
                      checked={aiResponseMode === 'Text'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>Text
                </label>

                <label htmlFor="voice" title='AI feedback form: voice' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px'}}>
                  <input
                      type="radio"
                      id="voice"
                      name="AIResponseMode"
                      value="Voice"
                      checked={aiResponseMode === 'Voice'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>Voice
                </label>
              </div>

              <label htmlFor="transcriptionmode-set" title='Voice transcription method: offline or real-time'> Transcribe mode:</label>
              <div id="transcriptionmode-set" style={{'display': 'flex'}}>
                <label htmlFor="realtime" title='Voice transcription method: Real-time' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px', 'margin-right': '15px'}}>
                  <input
                      type="radio"
                      id="realtime"
                      name="TranscriptionMode"
                      value="Real-time"
                      checked={transcriptionModeData === 'Real-time'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>Real-time
                </label>

                <label htmlFor="offline" title='Voice transcription method: Offline' className="custom-radio-label" style={{ 'font-size': '15px', 'font-weight': '400', 'margin-bottom': '15px'}}>
                  <input
                      type="radio"
                      id="offline"
                      name="TranscriptionMode"
                      value="Offline"
                      checked={transcriptionModeData === 'Offline'}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                  />
                  <span className="custom-radio-btn"></span>Offline
                </label>
              </div>


            { userVipLevel > 0 && 
            <>
              <label title='What do you need AI to do, such as specific scenarios and specific tasks? If your needs are precise enough, the answers you get will be accurate enough.' >GPT Prompt Content:</label>
              <p>Please enter custom GPT prompt content or you can keep the system default prompt set as follows.</p>
              {/* <div style={{ height: divHeightGPTPromptContent, width:'100%', 'margin-bottom':'15px'}}> */}
              <div className="textarea-div-settingpop">
                  <textarea 
                  // style={{ height: '200px'}}
                  ref={textAreaRefGPTPromptContent} 
                  className='textarea-settingpop'
                  onInput={handleInputGPTPromptContent} 
                  placeholder={textAreaValueGPTPromptContent !=='' ? textAreaValueGPTPromptContent : 'GPT Prompt Content'} 
                  value={textAreaValueGPTPromptContent}/>
              </div>
            </>}


            {/* <label title='Customize transcription style' >Transcript style:</label>
            <p>Please enter the transcription style you want, for example: writer, scientist, 
                philosopher, engineer, teacher, student, politician, host, DJ, rapper, gamer, 
                Hemingway, alien, billionaire, Athletes, hackers, speakers, experts, etc.
                Separate each rule with a comma.</p>
            <div className="textarea-div-settingpop">
                <textarea 
                ref={textAreaRefTranscript} 
                className='textarea-settingpop'
                onInput={handleInputTranscript} 
                placeholder={textAreaValueTranscript !==''  ? textAreaValueTranscript : 'Enter transcription style'} 
                value={textAreaValueTranscript}/>
            </div> */}

            <label title='Summary settings for transcribed text' >Summary Setting:</label>
            <p>The length and complexity of your Copilot responses</p>
            <div className="verbosity-control">
                <div className="verbosity-options">
                    <button
                        title='The most concise summary'
                        className={`verbosity-option ${summaryLength === 'Brief' ? 'active' : ''}`}
                        onClick={() => handleSummaryLengthChange('Brief')}  
                        >
                        Brief
                    </button>
                    <button
                        title='The most normal summary'
                        className={`verbosity-option ${summaryLength === 'Moderate' ? 'active' : ''}`}
                        onClick={() => handleSummaryLengthChange('Moderate')}
                        >
                        Moderate
                    </button>
                    <button
                        title='The most detailed summary'
                        className={`verbosity-option ${summaryLength === 'Precise' ? 'active' : ''}`}
                        onClick={() => handleSummaryLengthChange('Precise')}
                        >
                        Precise
                    </button>
                </div>
            </div>

            <label title='If you choose to start AI by keywords, this option will take effect. When the keywords set below appear in the transcription script, AI will start immediately.'>Keywords:</label>
            <p>Please enter the keywords to wake up AI and let it help you come up with ideas, for example: 
                I think, I think, this thing should be, this question, how, how, where, when, who, I think, 
                you think, you Think, you will, you should, how, or other words you think are appropriate. 
                As soon as you hear the word, the AI will be ready immediately. Separate each keyword with a comma.</p>
            {/* <div style={{ height: '300px', width:'100%' }}> */}
            <div className="textarea-div-settingpop">
                <textarea 
                ref={textAreaRefKeywords} 
                className='textarea-settingpop'
                onInput={handleInputKeywords} 
                placeholder={textAreaValueKeywords !=='' ? textAreaValueKeywords : 'Keywords'} 
                value={textAreaValueKeywords}/>
            </div>

            <label title='Setting the automatic stop time for transcription when there is no microphone input.' htmlFor="autostoptime-set">Silence detection timeout:</label>
              <select id="autostoptime-set" name="AutoStopTime" value={autoStopTimeData} onChange={handleInputChange} className="appstyle-mode-selector">
                {autoStopTimeOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

          {/* </div> */}

          {/* <div className="popup-settingsnew-right"> */}

          </div>
        </div>
            

        <div className="popup-settingsnew-footer">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="save-button" onClick={handleSavePreset}>Save</button>
        </div>
      </div>
    </div>

   
  );
};

export default SettingsPopup;
